export default __webpack_public_path__ + "static/media/character-other.3dd67315.png";